import React from 'react'
import clsx from 'clsx'
import './UserInitialsAvatar.scss'

export function getUserInitials(input: { firstName?: string | null; lastName?: string | null; fullName?: string | null }): string {
  const first = (input.firstName || '').trim()
  const last = (input.lastName || '').trim()
  if (first || last) {
    return `${first.charAt(0)}${last.charAt(0)}`.toUpperCase()
  }
  const name = (input.fullName || '').trim()
  if (name) {
    return name
      .split(/\s+/)
      .map((word) => word.charAt(0))
      .join('')
      .toUpperCase()
      .slice(0, 2)
  }
  return ''
}

type UserInitialsAvatarBaseProps = {
  firstName?: string | null
  lastName?: string | null
  fullName?: string | null
  className?: string
  initialsDataTestId?: string
}

type UserInitialsAvatarHeaderProps = UserInitialsAvatarBaseProps & {
  variant: 'header'
}

type UserInitialsAvatarProfileProps = UserInitialsAvatarBaseProps & {
  variant: 'profile'
}

export type UserInitialsAvatarProps = UserInitialsAvatarHeaderProps | UserInitialsAvatarProfileProps

export const UserInitialsAvatar: React.FC<UserInitialsAvatarProps> = (props) => {
  const { firstName, lastName, fullName, className, initialsDataTestId, variant } = props
  const initials = getUserInitials({ firstName, lastName, fullName })
  const defaultTestId = variant === 'header' ? 'account-widget-avatar-content-initials' : undefined

  return (
    <div className={clsx('user-initials-avatar', className)}>
      <span
        className="user-initials-avatar__initials subtitle-3"
        data-testid={initialsDataTestId ?? defaultTestId}
      >
        {initials}
      </span>
    </div>
  )
}
